import type { BaseModelBasicData } from '../data/model';
import { IEvent } from '../shared/EventAggregator';
import type { RequestQuoteFormData } from './RequestQuoteState';

export class RequestQuoteSubmittedEvent implements IEvent {
  constructor(
    public readonly product: BaseModelBasicData,
    public readonly configurationCode: string | undefined,
    public readonly formData: RequestQuoteFormData,
    public readonly currencyCode: string,
  ) {}
}
